import { ResponseMESF, useUTLSettingsContext } from "@dexteel/mesf-core";
import { Box, Divider, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { get } from "lodash-es";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { readHeatingsFromPLC } from "../../../repositories/eaf.repositories";
import { AgGridFooterActions } from "../components/AgGridFooterActions";
import { useEAFDETablesStyles } from "../styles/useEAFDETablesStyles";
import { useTableData } from "./hooks/useHeatingsTableData";

export const TableHeatings = () => {
	const { state } = useUTLSettingsContext();

	const MAX_HEATINGS = get(state.settings, "MAX_HEATINGS", 10);

	const {
		state: { deProcess, isProcessTimesLoading },
		actions: { setNotificationMessage, setErrorMessage },
	} = useDataEntryContext();
	const { refreshData } = useEAFDataEntryActions();

	const heatings = deProcess?.heatings;
	const rowCount = heatings ? heatings.length : 0;
	const hasMaxHeatings = (heatings && heatings.length >= MAX_HEATINGS) || false;

	const classes = useEAFDETablesStyles({ rowCount });
	const readFromPLC = async () => {
		const ProcessId = deProcess?.process?.ProcessId;

		if (ProcessId) {
			const resp = await readHeatingsFromPLC({ ProcessId });
			if (resp.ok) {
				await refreshData();
			} else {
				setErrorMessage(resp.message);
			}
			return resp;
		} else {
			setNotificationMessage("Process not found");
			return { ok: false, message: "Process not found" } as ResponseMESF;
		}
	};

	const { columns } = useTableData();

	return (
		<>
			<Paper>
				<Box padding={1} className={`${classes.heatingsAgGridBox}`}>
					<AgGridReact
						rowSelection="single"
						suppressRowClickSelection={true}
						pagination={false}
						singleClickEdit={false}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={heatings}
						columnDefs={columns}
						domLayout="normal"
						suppressContextMenu={true}
						loading={isProcessTimesLoading}
					/>
					<Divider />
					<AgGridFooterActions
						hasMaxItems={hasMaxHeatings}
						readFromPLC={readFromPLC}
						table="heatings"
					/>
				</Box>
			</Paper>
		</>
	);
};
